import { serviceInclud } from "../../../types/packageFlowModel";
import { TooltipLink } from "../../TooltipLink/TooltipLink";

const VisaApplicationUI = ({
  serviceInclude,
  setServiceInclude,
  serviceId,
  setServiceIcludePrice,
}: {
  serviceInclude: serviceInclud[];
  setServiceInclude?: any;
  serviceId: number;
  setServiceIcludePrice?: any;
}) => {
  const handleChangeCheckboxStatus = (priceRecordId: number) => {
    setServiceInclude((prev: serviceInclud[]) => {
      const currentValueIndex = prev.findIndex(
        (item) => item.PriceRecordId === priceRecordId
      );

      const updatedList = prev.map((item, index) => {
        if (index < currentValueIndex) {
          return { ...item, includes: 0 };
        } else if (index === currentValueIndex) {
          return { ...item, includes: item.includes === 1 ? 0 : 1 };
        } else {
          return { ...item, includes: 1 };
        }
      });
      const newTotal = updatedList
        .filter((item) => item.includes === 1)
        .reduce((total, item) => total + item.PriceAmount, 0);

      setServiceIcludePrice(newTotal);

      return updatedList;
    });
  };

  return (
    <div className="visa-process-wrapper">
      <div>
        <div className="visa-info-banner bg-beige text-noti font-11 p-2 px-2 my-2 ff-medium d-flex align-items-center justify-content-between gap-2 rounded-0">
          <div className="d-flex align-items-center gap-1">
            <svg
              width="13"
              height="13"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 0C6.01664 0 4.56659 0.439867 3.33323 1.26398C2.09986 2.08809 1.13856 3.25943 0.570907 4.62987C0.00324964 6.00032 -0.145275 7.50832 0.144114 8.96318C0.433503 10.418 1.14781 11.7544 2.1967 12.8033C3.2456 13.8522 4.58197 14.5665 6.03682 14.8559C7.49168 15.1453 8.99968 14.9968 10.3701 14.4291C11.7406 13.8614 12.9119 12.9001 13.736 11.6668C14.5601 10.4334 15 8.98336 15 7.5C15 5.51088 14.2098 3.60322 12.8033 2.1967C11.3968 0.790176 9.48913 0 7.5 0ZM7.5 13.3333C7.33518 13.3333 7.17407 13.2845 7.03703 13.1929C6.89999 13.1013 6.79318 12.9712 6.7301 12.8189C6.66703 12.6666 6.65053 12.4991 6.68268 12.3374C6.71484 12.1758 6.7942 12.0273 6.91075 11.9107C7.02729 11.7942 7.17578 11.7148 7.33743 11.6827C7.49908 11.6505 7.66663 11.667 7.81891 11.7301C7.97118 11.7932 8.10133 11.9 8.19289 12.037C8.28446 12.1741 8.33334 12.3352 8.33334 12.5C8.33334 12.721 8.24554 12.933 8.08926 13.0893C7.93298 13.2455 7.72102 13.3333 7.5 13.3333ZM8.33334 9.91667V10C8.33334 10.221 8.24554 10.433 8.08926 10.5893C7.93298 10.7455 7.72102 10.8333 7.5 10.8333C7.27899 10.8333 7.06703 10.7455 6.91075 10.5893C6.75447 10.433 6.66667 10.221 6.66667 10V9.16667C6.66667 8.94565 6.75447 8.73369 6.91075 8.57741C7.06703 8.42113 7.27899 8.33333 7.5 8.33333C7.99446 8.33333 8.4778 8.18671 8.88893 7.91201C9.30005 7.6373 9.62048 7.24686 9.8097 6.79004C9.99892 6.33323 10.0484 5.83056 9.95196 5.34561C9.8555 4.86065 9.6174 4.4152 9.26777 4.06557C8.91814 3.71593 8.47268 3.47783 7.98773 3.38137C7.50278 3.28491 7.00011 3.33442 6.54329 3.52363C6.08648 3.71285 5.69603 4.03328 5.42133 4.44441C5.14662 4.85553 5 5.33888 5 5.83333C5 6.05435 4.9122 6.26631 4.75592 6.42259C4.59964 6.57887 4.38768 6.66667 4.16667 6.66667C3.94566 6.66667 3.73369 6.57887 3.57741 6.42259C3.42113 6.26631 3.33334 6.05435 3.33334 5.83333C3.3335 5.04497 3.55731 4.27284 3.97878 3.6066C4.40025 2.94037 5.00209 2.40737 5.71438 2.06952C6.42668 1.73167 7.22021 1.60283 8.00281 1.69797C8.7854 1.7931 9.52495 2.1083 10.1356 2.60697C10.7462 3.10563 11.2028 3.76729 11.4524 4.5151C11.7019 5.26291 11.7342 6.06618 11.5455 6.83162C11.3568 7.59705 10.9548 8.29325 10.3862 8.83933C9.81761 9.38542 9.10577 9.75899 8.33334 9.91667Z"
                fill="#CF770C"
              />
            </svg>

            <span>
              Need help before you continue? Make sure steps are done or get in
              touch!
            </span>
          </div>
          <TooltipLink
            Id="contact-tooltip"
            placement="bottom"
            title={
              <div className="custom-tooltip-content px-2 py-2 ">
                <div className="tooltip-item d-flex align-items-center gap-3 py-2 border-bottom">
                  <div>
                    <img
                      src="https://goodhand.b-cdn.net/Assets/Flow/whatsapp.svg"
                      alt=""
                    />
                  </div>
                  <div>+971 42 97 9997</div>
                </div>
                <div className="tooltip-item tooltip-item d-flex align-items-center gap-3 py-2">
                  <div>
                    <img
                      src="https://goodhand.b-cdn.net/Assets/Flow/call-icon.svg"
                      alt=""
                    />
                  </div>
                  <div>+971 42 97 9998</div>
                </div>
                {/* <div className="tooltip-item tooltip-item d-flex align-items-center gap-3 py-2 ">
                  <div>
                    <img
                      src="https://goodhand.b-cdn.net/Assets/Flow/envelope.svg"
                      alt=""
                    />
                  </div>
                  <div> Chat with agent</div>
                </div> */}
              </div>
            }
            styleName="none"
          >
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
              }}
              className="text-black d-flex align-items-center gap-2 font-12"
            >
              <div>Need Help? </div>
              <span style={{ fontSize: "12px" }}>
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 6.25684C1 6.97911 1.14226 7.6943 1.41866 8.36159C1.69506 9.02889 2.10019 9.6352 2.61091 10.1459C3.12163 10.6566 3.72795 11.0618 4.39524 11.3382C5.06253 11.6146 5.77773 11.7568 6.5 11.7568C7.22227 11.7568 7.93747 11.6146 8.60476 11.3382C9.27205 11.0618 9.87836 10.6566 10.3891 10.1459C10.8998 9.6352 11.3049 9.02889 11.5813 8.36159C11.8577 7.6943 12 6.97911 12 6.25684C12 5.53457 11.8577 4.81937 11.5813 4.15208C11.3049 3.48479 10.8998 2.87847 10.3891 2.36775C9.87836 1.85703 9.27205 1.4519 8.60476 1.1755C7.93747 0.899098 7.22227 0.756836 6.5 0.756836C5.77773 0.756836 5.06253 0.899098 4.39524 1.1755C3.72795 1.4519 3.12163 1.85703 2.61091 2.36775C2.10019 2.87847 1.69506 3.48479 1.41866 4.15208C1.14226 4.81937 1 5.53457 1 6.25684Z"
                    stroke="black"
                    strokeWidth="1.22222"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.5 9.3125V9.31917"
                    stroke="black"
                    strokeWidth="1.22222"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.49957 7.17322C6.48831 6.97484 6.54183 6.77817 6.65205 6.61284C6.76227 6.44751 6.92323 6.32247 7.11068 6.25656C7.34038 6.16872 7.54655 6.02876 7.71297 5.8477C7.87939 5.66663 8.0015 5.44941 8.06971 5.21314C8.13791 4.97686 8.15034 4.72798 8.10601 4.48609C8.06168 4.24419 7.96181 4.01589 7.81426 3.81915C7.6667 3.62241 7.4755 3.46261 7.25569 3.35232C7.03588 3.24204 6.79348 3.18428 6.54755 3.1836C6.30163 3.18292 6.05891 3.23933 5.83849 3.34839C5.61808 3.45746 5.42599 3.6162 5.27734 3.81211"
                    stroke="black"
                    strokeWidth="1.22222"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </a>
          </TooltipLink>
        </div>
      </div>
      {serviceInclude &&
        serviceInclude?.map((step, index) => {
          const readOnly = serviceInclude.findIndex(
            (item) => item.serviceid === serviceId
          );
          return (
            <div
              className={`visa-step-item ${
                index === serviceInclude.length - 1
                  ? "no-border"
                  : "border-bottom"
              }`}
            >
              <div className="visa-step-label">
                <input
                  disabled={readOnly <= index ? true : false}
                  type="checkbox"
                  name={`serviceCompleted-${step.serviceid}`} // Unique per item
                  value="yes"
                  checked={step.includes === 1 ? true : false} // Set Yes checked if check is true
                  onChange={() =>
                    handleChangeCheckboxStatus(step.PriceRecordId)
                  }
                />
                <span
                  className={
                    readOnly <= index
                      ? step.serviceid === serviceId
                        ? "visa-complete ff-semibold font-12"
                        : "text-black-50 visa-complete ff-semibold font-12"
                      : "text-main visa-complete ff-semibold font-12"
                  }
                  dangerouslySetInnerHTML={{
                    __html: step.title ?? " ",
                  }}
                ></span>
              </div>
              <div>
                {index < serviceInclude.length && (
                  <>
                    <span className="visa-price-old font-12 text-black-50 d-none">
                      <span className="ff-currency ff-medium  font-16"></span>
                      {step?.oldPrice?.toFixed(2)}
                    </span>
                    <span
                      className={`visa-price-new font-13 text-black ${
                        readOnly <= index ? "text-black-50 " : "text-black"
                      }`}
                    >
                      <span className="ff-currency ff-medium  font-16"></span>
                      {step.PriceAmount.toFixed(2)}
                    </span>
                  </>
                )}
              </div>
            </div>
          );
        })}

      <style>{`
        .visa-step-label input[type="checkbox"] {
    accent-color: #385986;
  }
      .visa-check-icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 2px solid #476088;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
      }
      .visa-step-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.75rem 0;

      }
      .visa-step-label {
        display: flex;
        align-items: center;
      }
      .visa-step-label input[type='checkbox'] {
        width: 15px;
        height: 15px;
        margin-right: 1rem;
      }
      .visa-complete {
        color: #029002;
        font-weight: bold;
      }
      .visa-price-old {
        text-decoration: line-through;
        color: #a0a0a0;
        margin-right: 0.5rem;
      }
      .visa-price-new {
        color: #7e3ff2;
        font-weight: bold;
      }`}</style>
    </div>
  );
};

export default VisaApplicationUI;
